import { render } from "./Results7.vue?vue&type=template&id=1afa05ff&scoped=true"
import script from "./Results7.vue?vue&type=script&lang=js"
export * from "./Results7.vue?vue&type=script&lang=js"

import "./Results7.vue?vue&type=style&index=0&id=1afa05ff&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afa05ff"]])

export default __exports__